module.exports = __webpack_public_path__ + "static/media/przemiana1_left.6736ae16.jpeg";